import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({
  name: 'QuantityPicker',
})(({ brandColors, type, typography: { pxToRem } }) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    height: 'fit-content',
    padding: pxToRem(4),
    gap: pxToRem(8),
    borderRadius: pxToRem(100),
    border: `${pxToRem(1)} solid ${brandColors.tintsNeutral20}`,
  },
  quantityBox: {
    width: pxToRem(16),
    textAlign: 'center',
    userSelect: 'none',
    ...type['14_regular'],
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    border: 'none',
    backgroundColor: 'unset',
    color: 'black',
    borderRadius: pxToRem(100),
    padding: pxToRem(4),
    cursor: 'pointer',

    '&:disabled': { color: brandColors.tintsOffWhite40 },
    '&:hover': { backgroundColor: brandColors.interactiveHeroBlueSubtle },
    '&:focus-visible': {
      backgroundColor: brandColors.interactiveHeroBlueSubtle,
    },
  },
}));

export default useStyles;
